module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/zh-hant_4-b1e8cd1b32e39359fdf9fe78b28887df.jpg";